export default "__VITE_ASSET__DkpBLohz__"